import { Flex, Text } from '@spotify-internal/encore-web';
import { DemoTag } from '@spotify/confidence-core-react';

import { StateTag } from './StateTag';

interface TypeStatusRowProps {
  typeLabel: string;
  state?: string;
  demoLabels?: Array<{ key: string; value?: string | null }>;
}

export const TypeStatusRow = ({
  typeLabel,
  state,
  demoLabels,
}: TypeStatusRowProps) => (
  <Flex alignItems="center" gap="tighter-2">
    <Text variant="bodySmall" semanticColor="textSubdued">
      {typeLabel}
    </Text>
    {state && (
      <>
        <Text
          variant="bodySmall"
          semanticColor="textSubdued"
          aria-hidden="true"
        >
          &middot;
        </Text>
        <StateTag state={state} />
      </>
    )}
    <DemoTag labels={demoLabels} />
  </Flex>
);
